import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ValidateUserService } from '../validate-user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from '../login.service';
@Component({
  selector: 'app-candidate-login',
  templateUrl: './candidate-login.component.html',
  styleUrls: ['./candidate-login.component.scss']
})
export class CandidateLoginComponent implements OnInit {
  loginForm = new FormGroup({
    referenceId:new FormControl('',[Validators.required]),
    password:new FormControl('',[Validators.required])
  })
  constructor(
    private validateUserService:ValidateUserService,
    private router:Router,
    private loginService:LoginService,
    private snackBar:MatSnackBar
  ) { }

  ngOnInit(): void {
    console.log("In candidate login")

  }
  submit(){
    let cdePassword = ({
      caseId:this.loginForm.get('referenceId').value,
      password:this.loginForm.get('password').value
    })
    this.validateUserService.validateCdeUser(cdePassword).subscribe(
      response=>{
        if(response){
          localStorage.setItem('cdeAccessToken',response.accessToken);
          localStorage.setItem('referenceId',this.loginForm.get('referenceId').value);
          // this.loginService.loggedInBehaviorSubject.next(true);
          //          this.router.navigate(['welcome']);
          this.loginService.logIn() 
        }else{
          this.showError("User Id not found");
        }
      },
      
      error=>{
        console.log('error ',error);
        this.showError(error.error.message);
      }

    )
  }
  showMessage(msg){
    this.snackBar.open(msg,'Info',{duration:4000,horizontalPosition:'end',verticalPosition:'top'})
  }
  showError(msg){
    this.snackBar.open(msg,'Error',{duration:4000,horizontalPosition:'end',verticalPosition:'top'})
  }  

}
